import { createAction } from 'typesafe-actions';

import * as DesktopAppConstants from './constants';

type SetDeepLinkPathParams = $TSFixMe;
interface SetDeepLinkPathPayload {
  deepLinkPath: SetDeepLinkPathParams;
}

export const setDeepLinkPath = createAction(
  DesktopAppConstants.ActionKeys.SET_DEEP_LINK_PATH,
  (deepLinkPath: SetDeepLinkPathParams) => ({ deepLinkPath }),
)<SetDeepLinkPathPayload>();
export type SetDeepLinkPathAction = ReturnType<typeof setDeepLinkPath>;

type SetSourcePathParams = $TSFixMe;
interface SetSourcePathPayload {
  sourcePath: SetSourcePathParams;
}

export const setSourcePath = createAction(
  DesktopAppConstants.ActionKeys.SET_SOURCE_PATH,
  (sourcePath: SetSourcePathParams) => ({ sourcePath }),
)<SetSourcePathPayload>();
export type SetSourcePathAction = ReturnType<typeof setSourcePath>;
